
document.addEventListener('DOMContentLoaded', () => {
    if (document.querySelector('.mobileSwiper')) {
        new Swiper('.mobileSwiper', {
            slidesPerView: 'auto',
            spaceBetween: 16,
            freeMode: false,
        });
    }
});
